import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { History } from "history";
import { ApplicationState, reducers } from ".";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { createStateSyncMiddleware, initMessageListener } from "redux-state-sync";

export default function configureStore(history: History, initialState?: ApplicationState) {
    const config = {
        // Only 'TOGGLE_TODO' will be triggered in other tabs
        whitelist: ["RECEIVE_SOCIAL_MEDIA"],
    };
    const middleware = [thunk, routerMiddleware(history), createStateSyncMiddleware(config)];

    const appReducer = combineReducers({
        ...reducers,
        router: connectRouter(history),
    });

    const persistConfig = {
        key: "root",
        storage: storageSession,
        blacklist: ["router"],
    };

    const enhancers = [];
    const windowIfDefined = typeof window === "undefined" ? null : (window as any);
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const rootReducer = (state: any, action: any) => {
        // when a logout action is dispatched it will reset redux state

        if (action.type === "USER_LOGGED_OUT") {
            state = {
                configurationState: state.configurationState,
                router: state.router,
            };
        } else if (action.type === "RELOAD_USER_PERMISSION") {
            state = {
                loggedInUser: state.loggedInUser,
                configurationState: state.configurationState,
                productFeatureState: state.productFeatureState,
                creditState: state.creditState,
                router: state.router,
            };
        }

        return appReducer(state, action);
    };

    const persistedReducer = persistReducer(persistConfig, rootReducer);
    const store = createStore(persistedReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
    initMessageListener(store);
    const persistor = persistStore(store);

    return { store, persistor };
}
